import {
	UserController,
	SettingsController,
	BusinessController,
} from '../../controllers';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import { businessStore, useStores } from '../../stores';
import { OTP } from '../../pages';
import React, { useState } from 'react';

const OTPContainer = ({ route }) => {
	const { userStore } = useStores();
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const resendCode = async () => {
		const params = localStorage.getItem(constant.RouteParams);
		const { OtpType, email } = JSON.parse(params);
		OtpType === constant.OtpType.ONBOARDING
			? await UserController.resendCode(userStore.userId)
			: OtpType === constant.OtpType.BVNONBOARDING
				? await BusinessController.resendBVNCode()
				: await UserController.forgotPassword(email);

		MimaToastUtil.success({
			message: constant.TokenSent,
		});
	};

	const onSubmit = async token => {
		setLoading(true);
		//This is to be change to navigation params
		const params = localStorage.getItem(constant.RouteParams);
		const { OtpType } = JSON.parse(params);
		if (OtpType === constant.OtpType.FORGETPASSWORD) {
			const { status, errorMessage } =
				await UserController.validateForgetPasswordToken(token);
			if (status === constant.Success) {
				await SettingsController.dashboardData();
				setLoading(false);
				return navigate(constant.Routes.ResetPassword);
			}
			setLoading(false);
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		//This is to be change to navigation params
		if (OtpType === constant.OtpType.ONBOARDING) {
			const { status, errorMessage, data } =
				await UserController.activateUser(token);

			if (status === constant.Success) {
				if (data.token) {
					const { token, user, onbordingDone } = data || {};
					userStore.setUser(user);
					userStore.setOnBoardingDone(onbordingDone);
					localStorage.setItem('token', token);
					userStore.setActivated(true);
					userStore.setLoggedIn(true);
					businessStore.setBId(user.business._id);
					businessStore.setBusinesses(user.businesses);
					businessStore.setBusiness(user.business);
					setLoading(false);
					return navigate(constant.Routes.AppHome);
				}
				setLoading(false);
				return navigate(constant.Routes.AccountInReview);
			}
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		if (OtpType === constant.OtpType.BVNONBOARDING) {
			const { status, errorMessage } =
				await BusinessController.activateBvn(token);
			if (status === constant.Success) {
				await SettingsController.dashboardData();
				setLoading(false);
				return navigate(
					!localStorage.getItem(constant.RoutePath)
						? constant.AppHome
						: localStorage.getItem(constant.RoutePath)
				);
			}
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};

	return <OTP onSubmit={onSubmit} loading={loading} resendCode={resendCode} />;
};

export default observer(OTPContainer);
